<div class="content">
    <div class="message" [ngClass]="{ 'message-success': data.success, 'message-error': !data.success }">
        <p>{{data.message}}</p>
    </div>
</div>